/* eslint-disable func-names */
/* globals jQuery, ga */

const googleAnalytics = {
  all() {
    // Benefits Click
    jQuery('.benefits-grid a').on('click', function() {
      const linktitle = jQuery(this)
        .parents('.text-normal')
        .find('h4')
        .html();
      ga(
        'send',
        'event',
        'Benefits Click',
        window.location.pathname,
        linktitle
      );
    });

    // Email Newsletter Signup Click
    jQuery('#gform_submit_button_27').on('click', function() {
      ga(
        'send',
        'event',
        'Newsletter Signup Click',
        window.location.pathname,
        'Header'
      );
    });

    // Outbound Link Click
    jQuery("a[href='https://itunes.apple.com/app/id458068095?mt=8']").on(
      'click',
      function() {
        ga(
          'send',
          'event',
          'Outbound Click',
          'Dashboard App Download Click',
          'iPhone'
        );
      }
    );
    jQuery(
      "a[href='https://play.google.com/store/apps/details?id=com.shopkeep.dashboard']"
    ).on('click', function() {
      ga(
        'send',
        'event',
        'Outbound Click',
        'Dashboard App Download Click',
        'Android'
      );
    });

    // Get Started Click
    jQuery("a[href='/signup']").on('click', function() {
      let gsmessage = '';
      // Check if signup click came from main nav in header or elsewhere
      if (jQuery(this).parents('#main-nav').length) {
        gsmessage = ' (Header)';
      }
      ga(
        'send',
        'event',
        'UI Event',
        'Get Started Click',
        window.location.pathname + gsmessage
      );
    });

    // Open Video
    jQuery('a.video-icon, .more-link.mfp-iframe').on('click', function() {
      let videoTitle = jQuery(this).text();
      if (!videoTitle) videoTitle = jQuery(this).attr('title');

      ga('send', 'event', 'Open Video', window.location.pathname, videoTitle);
    });

    // FAQ Event
    jQuery('.faq-section .ui-accordion-header a').on('click', function() {
      const linktitle = jQuery(this).text();
      ga('send', 'event', 'UI Event', 'FAQ Click', linktitle);
    });

    // Merchant Referral
    jQuery('#backoffice-share-link').on('click', function() {
      ga(
        'send',
        'event',
        'UI Event',
        'Merchant Referral',
        'Referral Login Link'
      );
    });

    // Content Site Header Click
    jQuery('#catNavBar_skCustom #topCats .topCat').on('click', function() {
      const linktitle = jQuery(this)
        .find('h4')
        .text();
      ga(
        'send',
        'event',
        'Content Site Header Link Click',
        window.location.pathname,
        linktitle
      );
    });

    // Content Site Header Subnav Click
    jQuery('#navSubCat .subCat a').on('click', function() {
      const linktitle = jQuery(this).text();
      ga(
        'send',
        'event',
        'Content Site Header Link Click',
        window.location.pathname,
        linktitle
      );
    });

    // Newsletter Signup for Sidebar
    jQuery("#sidebar #gform_wrapper_9 input[type='submit']").on(
      'click',
      function() {
        ga(
          'send',
          'event',
          'Newsletter Signup Click',
          window.location.pathname,
          'Sidebar'
        );
      }
    );

    // Lead Form Submission Click
    if (jQuery('.page-template-v2').length === 0) {
      jQuery(".gform_wrapper input[type='submit']").on('click', function() {
        ga(
          'send',
          'event',
          'Lead Form Submission Click',
          window.location.pathname
        );
      });
    }

    // Online Chat Click
    jQuery('#SnapABug_Button').on('click', function() {
      ga('send', 'event', 'Online Chat Click', window.location.pathname);
    });

    // Colored Box Click
    jQuery('.color-box').on('click', function() {
      const linkurl = jQuery(this).attr('onclick');
      ga(
        'send',
        'event',
        'Colored Box Click',
        window.location.pathname,
        linkurl
      );
    });

    // Colored Box Click - POS Software Page
    jQuery('.shortcode-banner-link').on('click', function() {
      const linkurl = jQuery(this).attr('onclick');
      ga(
        'send',
        'event',
        'Colored Box Click',
        window.location.pathname,
        linkurl
      );
    });

    // Internal Link Click - Case Studies Landing Page
    jQuery('.rollover-project').on('click', function() {
      const linktitle = jQuery(this).text();
      const linkurl = jQuery(this).attr('href');
      ga(
        'send',
        'event',
        'Internal Link Click',
        window.location.pathname,
        `${linktitle} - ${linkurl}`
      );
    });

    // ShopKeep Logo Click - Regular Nav
    jQuery('#branding a').on('click', function() {
      ga(
        'send',
        'event',
        'ShopKeep Logo Click',
        window.location.pathname,
        'Regular Nav'
      );
    });

    // ShopKeep Logo Click - Sticky Nav
    jQuery('.logo-box a').on('click', function() {
      ga(
        'send',
        'event',
        'ShopKeep Logo Click',
        window.location.pathname,
        'Sticky Nav'
      );
    });

    // Promo Bar Click
    jQuery('#promo-bar a').on('click', function() {
      const linktitle = jQuery(this).text();
      const linkurl = jQuery(this).attr('href');
      ga(
        'send',
        'event',
        'Promo Bar Click',
        window.location.pathname,
        `${linktitle} - ${linkurl}`
      );
    });

    // Modal Click
    jQuery('.hp-campaign-hardware-learnmore').on('click', function() {
      const linktitle = jQuery(this).text();
      const linkurl = jQuery(this).attr('href');
      ga(
        'send',
        'event',
        'Modal Click',
        window.location.pathname,
        `${linktitle} - ${linkurl}`
      );
    });

    // Form Confirmation Page Click
    jQuery('.gform_confirmation_message a').on('click', function() {
      const linktitle = jQuery(this).text();
      const linkurl = jQuery(this).attr('href');
      ga(
        'send',
        'event',
        'Form Confirmation Page Click',
        window.location.pathname,
        `${linktitle} - ${linkurl}`
      );
    });

    // Stripe Click
    jQuery('.notice a').on('click', function() {
      const linktitle = jQuery(this).text();
      const linkurl = jQuery(this).attr('href');
      ga(
        'send',
        'event',
        'Stripe Click',
        window.location.pathname,
        `${linktitle} - ${linkurl}`
      );
    });

    // Stripe Close Click
    jQuery('.close-notice').on('click', function() {
      const linktitle = jQuery(this).text();
      const linkurl = window.location.href;
      ga(
        'send',
        'event',
        'Stripe Close Click',
        window.location.pathname,
        `${linktitle} - ${linkurl}`
      );
    });

    // Form Submission Error - Gravity Forms
    function trackErrorMsg() {
      if (jQuery('.gfield_error').length > 0) {
        jQuery('.gfield_error').each(function() {
          if (jQuery(this).text().length > 1) {
            ga(
              'send',
              'event',
              'Form Submission Error',
              window.location.pathname,
              jQuery(this).text()
            );
          }
        });
      }
    }

    // Form Submission Error - Signup
    function trackErrorMsgSignup() {
      if (jQuery('.validate-message.active').length > 0) {
        jQuery('.validate-message.active').each(function() {
          if (jQuery(this).text().length > 1) {
            const errormessage = jQuery(this)
              .parent('label')
              .text();
            ga(
              'send',
              'event',
              'Form Submission Error',
              window.location.pathname,
              errormessage
            );
          }
        });
      }
    }

    jQuery('#trial-signup-submit').on('click', function() {
      setTimeout(trackErrorMsgSignup, 2000);
    });

    jQuery(".gform_wrapper input[type='submit']").on('click', function() {
      setTimeout(trackErrorMsg, 2000);
    });

    // How it Works Nav Click
    jQuery('.how-it-works-menu .menu-item a').on('click', function() {
      const linktitle = jQuery(this).text();
      ga(
        'send',
        'event',
        'How it Works Navigation Click',
        window.location.pathname,
        linktitle
      );
    });
  }
};

export default googleAnalytics;
